import Modal from "@/components/design-system/modal";
import ToastSuccessCheckIcon from "public/next-public/common/icons/toast-success-check-icon.svg";
import { FunctionComponent } from "react";
import style from "./notifyMeModalConfirmationPage.module.scss";

const NotifyMeConfirmationModal: FunctionComponent<NotifyMeModalConfirmationPageProps> = ({
  isVisible,
  closeCallback,
}) => {
  const closeModal = () => {
    closeCallback();
  };

  return (
    <Modal size="skinny" sizeDownMd="medium" show={isVisible} onHide={closeModal} title="Notify Me When Available">
      <div className={style.content}>
        <ToastSuccessCheckIcon className={style.checkIcon} width={48} height={48} aria-hidden />
        <div className={style.heading}>You&rsquo;ll be notified when this is back in stock!</div>
        <div className={style.detailText}>
          You&rsquo;ll receive an email when the product is back in stock and ready for you to order. If you have any
          questions in the meantime, please feel free to contact our customer success team via live chat.
        </div>
      </div>
    </Modal>
  );
};

export type NotifyMeModalConfirmationPageProps = {
  isVisible: boolean;
  closeCallback: () => void;
};

export default NotifyMeConfirmationModal;
